import React, { Component } from "react";
import { Row } from "react-bootstrap";

import ChooseProductPopup from "../components/ChooseProductPopup";
import ProductItem from "../components/ProductItem";

import clientAPI from "../service/ClientAPI";
import { Paper, TextField, InputAdornment, Typography } from "@mui/material";
import { Search } from '@mui/icons-material';

class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchProduct: null,
            products: [],
            showPopup: false,
            selectedProduct: null
        }
    }

    componentDidMount() {
        clientAPI.RequestProducts()
            .then(_products => {
                this.setState({ products: _products })
            })
            .catch(console.error);
    }

    selectedProduct = (product) => {
        this.setState({ selectedProduct: product, showPopup: true });
    }

    render() {
        return (
            <div style={{ marginBottom: "10px" }}>
                <div style={{ 
                    maxWidth: "80%", 
                    margin: "auto", 
                    minHeight: "95vh", 
                    paddingBottom: "80px",
                    width: "95%",
                }}>
                    <h3 id="products" style={{ 
                        marginBottom: window.innerWidth < 600 ? "16px" : "20px", 
                        textAlign: "center", 
                        marginTop: window.innerWidth < 600 ? "20px" : "35px",
                        fontSize: window.innerWidth < 600 ? "1.5rem" : window.innerWidth < 900 ? "1.8rem" : "2.2rem",
                        fontWeight: 700,
                        color: "#2e7d32"
                    }}>
                        Verfügbare Produkte
                    </h3>

                    <Paper 
                        elevation={3} 
                        sx={{ 
                            p: { xs: 1.5, sm: 2.5 }, 
                            mb: { xs: 3, sm: 4 }, 
                            bgcolor: "white",
                            borderRadius: 3,
                            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.08)"
                        }}
                    >
                        <TextField
                            size="medium"
                            placeholder="Suche nach Produkt (Name)"
                            value={this.state.searchProduct || ''}
                            onChange={(e) => this.setState({ searchProduct: e.target.value })}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search sx={{ color: "#2e7d32" }} />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '10px',
                                    '&:hover fieldset': {
                                        borderColor: '#2e7d32',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#2e7d32',
                                    },
                                }
                            }}
                            fullWidth
                        />
                    </Paper>
                    <div style={{ 
                        display: "flex", 
                        flexWrap: "wrap",
                        gap: "24px",
                        justifyContent: "flex-start"
                    }}>
                        {
                            this.state.products
                                .filter(_product => _product.Published && 
                                    (this.state.searchProduct ? _product.Name.toLowerCase().includes(this.state.searchProduct.toLowerCase()) : true))
                                .sort((a, b) => {
                                    if (a.Name < b.Name) return -1;
                                    if (a.Name > b.Name) return 1;
                                    return 0;
                                })
                                .map(_product => {
                                return (
                                    <ProductItem key={_product.ID} product={_product} selectedProduct={this.selectedProduct} />
                                );
                            })
                        }
                    </div>
                </div>
                <ChooseProductPopup show={this.state.showPopup} product={this.state.selectedProduct} onClose={() => this.setState({ showPopup: false })} />
            </div>
        )
    }
}

export default Home;